package com.example.histoire.web

import kotlinx.browser.localStorage
import kotlinx.serialization.Serializable
import kotlinx.serialization.decodeFromString
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json

private const val KEY = "histoire_reader_ui_prefs_v1"

private val json =
    Json {
        ignoreUnknownKeys = true
        encodeDefaults = true
    }

@Serializable
data class ReaderUiPrefs(
    /** auto | light | dark | custom */
    val textMode: String = "auto",
    val textColorHex: String = "#F8FAFC",
    val backdropEnabled: Boolean = false,
    val backdropColorHex: String = "#0F172A",
    /** 0–100 */
    val backdropOpacityPercent: Int = 45,
)

fun loadReaderUiPrefs(): ReaderUiPrefs {
    val raw = localStorage.getItem(KEY)?.trim().orEmpty()
    if (raw.isBlank()) return ReaderUiPrefs()
    return runCatching { json.decodeFromString(ReaderUiPrefs.serializer(), raw) }.getOrElse { ReaderUiPrefs() }
}

fun saveReaderUiPrefs(prefs: ReaderUiPrefs) {
    localStorage.setItem(KEY, json.encodeToString(prefs))
}
